import { Button, Link, paletteHelper, spacingHelper, Text } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { usePcaChatModalContext } from '../../contexts/PcaChatModalContext';
import { ChatHeader } from '../ChatHeader/ChatHeader';
import { ChatWrapper } from '../ChatWrapper/ChatWrapper';

const PcaChatWelcomeScreenWrapper = styled(ChatWrapper)`
  display: flex;
  flex-direction: column;
`;

const StartCompareButton = styled(Button)`
  background: linear-gradient(90deg, #e4002b 0%, #8800b2 50%, #e4002b 100%);
`;
const WelcomeText = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 50px;
`;
const HelloText = styled(Text)`
  background: linear-gradient(92.09deg, #a70185 -4.92%, #d60142 103.87%);
  -webkit-background-clip: text; /* stylelint-disable-line property-no-vendor-prefix */
  -webkit-text-fill-color: transparent;
  background-clip: text; /* For newer browsers */
  display: inline-block; /* Important for sizing */
  font-weight: 500;
  font-size: ${spacingHelper('large')};
  line-height: 35px;
  letter-spacing: 0;
  margin-bottom: ${spacingHelper('extraSmall')};
`;

const DescriptionText = styled(Text)`
  margin-bottom: ${spacingHelper('large')};
  color: ${paletteHelper('textSecondary')};
  text-align: center;
`;
const DisclaimerText = styled(Text)`
  color: ${paletteHelper('textSecondary')};
  margin: ${spacingHelper('large')};
  text-align: center;
`;

export const PcaChatWelcomeScreen = () => {
  const { setPcaChatModalState } = usePcaChatModalContext();

  return (
    <PcaChatWelcomeScreenWrapper>
      <ChatHeader />
      <WelcomeText>
        <HelloText>Hello</HelloText>
        <DescriptionText variant="subtitle02">
          I&apos;m your new AI-powered tool, designed to simplify property comparisons by analysing
          price, location, features, and more.
        </DescriptionText>
        <StartCompareButton onClick={() => setPcaChatModalState('chat')}>
          Start comparing
        </StartCompareButton>
      </WelcomeText>
      <DisclaimerText variant="caption">
        Your personal information and conversational data will be saved for 30 days for quality
        analysis and to improve our systems to serve you better. Your data is protected and
        automatically deleted after this period. We do not use your information for any other
        purpose. Our{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.realestate.com.au/legal/privacy-policy"
        >
          Privacy Policy
        </Link>{' '}
        explains how we store personal information and your rights regarding data access,
        correction, and complaints.
      </DisclaimerText>
    </PcaChatWelcomeScreenWrapper>
  );
};
